import PropTypes from 'prop-types';
import ODropDownMenu from '../../../../UI/DropDownMenu/ODropDownMenu';

const GridOptions = ({
  children,
  handleOpenDialog,
  getEditData,
  handleOpenDokumenta,
}) => {
  const options = [
    {
      title: 'Izmeni',
      subtitle: 'Izmenite podatke izabrane lokacije',
      path: 'profil',
      id: 1,
      icon: 'fas fa-pen',
      color: '#2f3a3f',
      onClick: () => getEditData(),
    },
    {
      title: 'Dokumenti',
      subtitle: 'Lista dokumenata',
      path: 'profil',
      id: 2,
      icon: 'fas fa-file',
      color: '#2f3a3f',
      onClick: () => handleOpenDokumenta(),
    },
    {
      title: 'Obriši',
      subtitle: 'Obrišite izabranu lokaciju',
      path: 'login',
      id: 2,
      icon: 'fas fa-trash',
      color: '#ff5552',
      onClick: () => handleOpenDialog(),
    },
  ];

  return (
    <ODropDownMenu align="end" position="anchor" options={options}>
      {children}
    </ODropDownMenu>
  );
};

GridOptions.propTypes = {
  children: PropTypes.node.isRequired,
  handleOpenDialog: PropTypes.func.isRequired,
  getEditData: PropTypes.func.isRequired,
};

export default GridOptions;
